var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pagenationtopimg"},[(_vm.open == 1)?[_c('img',{attrs:{"src":require("../../../public/img/pagenation/pagenationtopimg.jpg"),"alt":""}})]:[_c('div')]],2)}
var staticRenderFns = []

export { render, staticRenderFns }